<template>
   <div class="table-controls">
      <div class="controls-info">
         <span class="total-label">{{ $t("taskRequestList_totalRequests") }}</span>
         <span class="count-badge">{{ totalCount }}</span>
      </div>

      <div class="controls-actions">
         <div class="left-section">
            <div class="filter-select">
               <select v-model="localFilter" @change="$emit('filter-change', localFilter)">
                  <option value="-1">{{ $t("gtsGrid_showAll") }}</option>
                  <option v-for="opt in filterOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
               </select>
               <Icon name="chevron-selector-vertical" />
            </div>

            <div class="action-buttons">
               <button class="icon-btn" :title="$t('common_print')" @click="$emit('print')">
                  <Icon name="printer" />
               </button>
               <button class="icon-btn" :title="$t('common_export')" @click="$emit('export')">
                  <Icon name="download-01" />
               </button>
               <button class="icon-btn" :title="$t('common_columns')" @click="$emit('columns')">
                  <Icon name="columns-03" />
               </button>
            </div>
         </div>

         <div class="search-input">
            <Icon name="search-md" />
            <input type="text" :placeholder="$t('common_search')" v-model="localSearch" @input="$emit('search', localSearch)" />
         </div>
      </div>
   </div>
</template>

<script>
import Icon from "@/components/atoms/Icon.vue";

export default {
   name: "TaskRequestTableControls",
   components: { Icon },
   props: {
      totalCount: { type: Number, default: 0 },
      filterOptions: { type: Array, default: () => [] },
   },
   data() {
      return {
         localFilter: "-1",
         localSearch: "",
      };
   },
};
</script>

<style lang="scss" scoped>
.table-controls {
   display: flex;
   flex-direction: column;
   gap: 16px;
   padding-top: 28px;

   .controls-info {
      display: flex;
      align-items: center;
      gap: 4px;
   }

   .total-label {
      font-size: 18px;
      font-weight: 500;
      color: #121619;
      line-height: 26px;
   }

   .count-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0 6px;
      border-radius: 8px;
      background-color: #f2f4f8;
      font-size: 12px;
      font-weight: 500;
      color: #121619;
      line-height: 26px;
   }

   .controls-actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
   }

   .left-section {
      display: flex;
      align-items: center;
      gap: 11px;
   }

   .filter-select {
      position: relative;
      display: flex;
      align-items: center;
      width: 128px;
      height: 40px;
      border: 1.5px solid #a2a9b0;
      border-radius: 8px;
      background: white;
      padding: 0 4px 0 12px;

      select {
         flex: 1;
         border: none;
         background: transparent;
         appearance: none;
         font-size: 14px;
         color: #21272a;
         cursor: pointer;
         outline: none;
         min-width: 0;
      }
   }

   .action-buttons {
      display: flex;
      align-items: center;
   }

   .icon-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      padding: 8px;
      border: none;
      background: transparent;
      border-radius: 8px;
      cursor: pointer;
      transition: background-color 0.15s;

      &:hover {
         background-color: var(--gray-100);
      }

      .ui-icon {
         width: 32px;
         height: 32px;
      }
   }

   .search-input {
      display: flex;
      align-items: center;
      width: 216px;
      height: 40px;
      border: 1.5px solid #a2a9b0;
      border-radius: 8px;
      background: white;

      .ui-icon {
         flex-shrink: 0;
         width: 20px;
         height: 20px;
         margin: 0 6px;
      }

      input {
         flex: 1;
         border: none;
         background: transparent;
         outline: none;
         font-size: 14px;
         color: #21272a;
         padding-right: 8px;

         &::placeholder {
            color: #697077;
         }
      }
   }
}
</style>
